<div class="flex h-80 items-start gap-2">
  <ng-container *ngIf="!maxDaysInRange || maxDaysInRange >= 7">
    <app-time-period-panel
      [excludedRanges]="excludedRanges"
      (selectedChange)="selectedChange($event)"
    ></app-time-period-panel>
    <div class="h-full w-0 border-r-[1px]"></div>
  </ng-container>
  <mat-calendar
    [selected]="selectedRangeValue"
    (selectedChange)="selectedChange($event)"
    [headerComponent]="headerComponent"
    [maxDate]="endDate"
    [minDate]="startDate"
  ></mat-calendar>
</div>
